import React from "react";

import { PoolName } from "@/shared/constants/pools";
import { ChainName } from "@/shared/types/networks";

import {
  arbitrumGoerliPools,
  arbitrumPools,
  polygonPools,
} from "../../constants/active-pools";
import { getTokensByPoolName } from "../../utils/get-tokens-by-pool-name";
import { Tabs } from "./styled";
import { Tab } from "./tab";

interface Props {
  value: PoolName;
  onChange: (value: PoolName) => void;
  className?: string;
  chainName: ChainName;
}

export const PoolTabGroupe: React.FC<Props> = ({
  value,
  onChange,
  className,
  chainName,
}) => {
  const getTabsByPoolName = (poolName: PoolName) => {
    return (
      <Tab
        key={poolName}
        tokens={getTokensByPoolName(poolName)}
        isActive={value === poolName}
        onClick={() => onChange(poolName)}
      />
    );
  };

  const tabsByChainName = {
    [ChainName.ArbitrumGoerli]: arbitrumGoerliPools.map(getTabsByPoolName),
    [ChainName.PolygonMumbai]: polygonPools.map(getTabsByPoolName),
    [ChainName.Arbitrum]: arbitrumPools.map(getTabsByPoolName),
  };

  return <Tabs className={className}>{tabsByChainName[chainName]}</Tabs>;
};
